module.exports = __webpack_public_path__ + "assets/Xi.687ea38219d96f24b9091e4704e5cea9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x/Xi.png
// module id = 802
// module chunks = 0